module.exports = __webpack_public_path__ + "img/plus.348003e8.svg";